import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { Menu } from '../model/menu';

@Injectable()
export class MenuService {

    PATH = environment.API_BASE + '/Menu';

    selectedMenu: Menu;

    onSelectedMenu(menu: Menu) {
        this.selectedMenu = menu;
    }

    constructor(
        private http: HttpClient
    ) { }

    // Coge todas las direcciones
    getMenus(): Observable<Menu[]> {
        return this.http.get<Menu[]>(this.PATH)
            .pipe(map(menus => menus.map(menu => Menu.toModel(JSON.stringify(menu)))));
    }

}
